<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-2 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3  text-white">
                  Nexus
                  <span>Aplicación de escritorio</span>
                </h1>
                <p class="lead  text-white">
                  Una aplicación diseñada para trabajar con TODAS tus ideas al mismo tiempo.
                </p>
                <div class="btn-wrapper">
                  <!-- <p class="lead text-white">
                    This web app can be generated in Vue.js combined with
                    Express / Flask or Laravel. Your choice :)
                  </p> -->
                  <a
                    target="_blank"
                    href="#"
                    class="btn btn-white btn-icon mb-3 mb-sm-0"
                    v-scroll-to="'#contacto'"
                  >
                    <i style="color: red" class="fa fa-rocket"></i>
                    <span class="btn-inner--text"
                      >Solicitar Demo</span
                    >
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <div  class="parallax-container mt--150">
      <parallax fixed>
        <img :src="'img/mockup-nexus.jpg'"/>
      </parallax>
    </div>
    <div class="profile-page">
        <section class="section section-skew">
        <div class="container">
            <card shadow class="card-profile mt--300" no-body>
            <div class="px-4">
                <div class="row justify-content-center">
                <div class="col-lg-3 order-lg-2">
                    <div class="card-profile-image">
                    <a href="#">
                        <img
                        v-lazy="'img/sq_nexus.png'"
                        class="rounded-circle rounded-notin bg-white"
                        />
                    </a>
                    </div>
                </div>
                <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
        
                </div>
                <div class="col-lg-4 order-lg-1">
                    <div class="card-profile-stats d-flex justify-content-center">
                
                    </div>
                </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 text-center mt-5"><br><br><br>
                        <h1>
                            NEXUS
                        </h1>
                    </div>
                </div>
                <div class="mt-5 py-5 border-top text-justify">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                    <p>
                        Nexus es una aplicación de escritorio que permite trabajar con todos los datos de la notaría. Está pensada para permitir interrelacionar elementos que las aplicaciones tradicionales trabajan de forma separada. Junte imágenes, documentos de diferentes fuentes, fichas de datos y haga operaciones que los involucren y tareas desatendidas que los traten. Todo ello, ADEMÁS, de las operaciones tradicionales de una aplicación diseñada para asistir a su trabajo. 
                    </p>
                    
                    <!-- <a href="#">Show more</a> -->
                    </div>
                    <div class="row">
                    <div class="col-lg-12 mb-4 px-5">
                      <h3>Funcionalidades</h3>
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-lg-6 mb-4 px-5">
                      <ul class="list-unstyled mt-2">
                          
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-blue text-white"
                              icon="fa fa-book"
                              ></badge>
                              <h6 class="mb-0">Escrituras</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-purple text-white"
                              icon="fa fa-book "
                              ></badge>
                              <h6 class="mb-0">Pólizas</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-indigo text-white"
                              icon="fa fa-book "
                              ></badge>
                              <h6 class="mb-0">Legitimaciones</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-orange text-white"
                              icon="fa fa-folder-open "
                              ></badge>
                              <h6 class="mb-0">Expedientes</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3"
                              icon="fa fa-user"
                              ></badge>
                              <h6 class="mb-0">Clientes</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-pink text-white"
                              icon="fa fa-calendar"
                              ></badge>
                              <h6 class="mb-0">Agenda</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-yellow text-white"
                              icon="fa fa-tasks"
                              ></badge>
                              <h6 class="mb-0">Tareas</h6>
                          </div>
                          </li>
                          <li class="py-2">
                          <div class="d-flex align-items-center">
                              <badge
                              type="success"
                              circle
                              class="mr-3 bg-orange text-white"
                              icon="fa fa-plus "
                              ></badge>
                              <h6 class="mb-0">Y próximamente mucho más... </h6>
                          </div>
                          </li>
                      </ul>
                    </div>
                    <div class="col-lg-6">
                      <img class="w100" v-lazy="'img/infografia-nexus.png'"/>
                    </div>
                    <!-- <a href="#">Show more</a> -->
                  </div>
                </div>
                </div>
            </div>
            </card>
        </div>
        </section>
    </div>

    <section class="section section section-shaped my-0 overflow-hidden pb-200 bg-gris">
      <div class="shape shape-style-1 bg-gradient-warning shape-skew zindex0">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-lg-2 ml-lg-auto">
            <div class="position-relative pl-md-5">
              <img src="img/ill/ill-2.svg" class="img-center img-fluid" />
            </div>
          </div>
          <div class="col-lg-6 order-lg-1">
            <div class="d-flex px-3">
              <div>
                <icon
                  name="ni ni-building"
                  size="lg"
                  class="bg-gradient-white"
                  color="primary"
                  shadow
                  rounded
                ></icon>
              </div>
              <div class="pl-4">
                <h4 class="display-3 text-white">Tareas definidas</h4>
                <p class="text-white">
                  Lance tareas generales de trabajo que el sistema realiza por usted mientras se dedica a otras operaciones.
                </p>
              </div>
            </div>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="ni ni-satisfied"
                    gradient="success"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-success">Soporte Técnico</h5>
                  <p>
                    Nuestro equipo de soporte técnico estará disponible siempre que nos necesite.
                  </p>
                  <a href="#" class="text-success">Más información</a>
                </div>
              </div>
            </card>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="ni ni-active-40"
                    gradient="warning"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-warning">Notin Academy</h5>
                  <p>
                    Realizamos <b>Talleres de Formación OnLine</b>, videos de <b>Cursos Express</b> y documentación detallada de nuestros productos.
                  </p>
                  <a href="#" class="text-warning">Más Información</a>
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>
    
  </div>
</template>

<script>

export default {
  name: "hash",
    components:{
        Parallax: () => import('vue-parallaxy'),
    }

};
</script>
<style scoped>

</style>